import { Offcanvas } from "bootstrap";

export const openOffcanvas = (offcanvasId: string) => {
  const el = document.getElementById(offcanvasId);
  if (!el) return;
  Offcanvas.getOrCreateInstance(el).show();
};
